import filter from '@/js/util/symbols/filter'

export default {
  inject: { filter },
  props: {
    tag: {
      type: String,
      default: 'ul',
      validator: tag => ['ol', 'ul'].includes(tag),
    },

    items: {
      type: Array,
      default: () => ([]),
    },
  },

  created() {
    this.emitFilterEvent('create:filtered', this.handleFilterChecked)
  },

  computed: {
    activeCheckboxType() {
      return this.filter.activeCheckbox.type
    },
    filterChecked() {
      return this.items.filter(({ type }) => type === this.activeCheckboxType)
    },
    handleFilterChecked() {
      const { filterChecked } = this
      return !filterChecked || !filterChecked.length ? this.items : filterChecked
    },
  },

  methods: {
    emitFilterEvent(...params) {
      this.filter.$emit(...params)
    },
  },

  watch: {
    handleFilterChecked(checked) {
      // set the array filtered to 0 if
      // loadmore needs to to reset on each
      // filter selection
      this.emitFilterEvent('create:filtered', checked)
    },
  },

  render(createElement) {
    const { amountShown } = this.filter
    const dispatchedData = {
      amountShown,
      items: this.handleFilterChecked,
    }
    return createElement(this.tag, this.$scopedSlots.default(dispatchedData))
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterResultsList.js